export default "/images/vendor/flag-icons/flags/1x1/eh.svg?ee7714bbc16678c4242b8277749f5ec0";